import { render, staticRenderFns } from "./BaseInfo.vue?vue&type=template&id=70a13c52&scoped=true&"
import script from "./BaseInfo.vue?vue&type=script&lang=js&"
export * from "./BaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./BaseInfo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BaseInfo.vue?vue&type=style&index=1&id=70a13c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a13c52",
  null
  
)

export default component.exports